<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div slot="no-body" class="tabs-container px-6">
		<div class="mb-2" style="border: 1px solid #e4e4e4; border-radius: 10px">
			<floating-buttons
				:titleHeader="$t('BreakTable.Action')"
				:cancelText="$t('MODULE_PERMISSION.Cancel')"
				:disabledSave="!validateForm"
				:saveText="$t('Save')"
				@save="save_changes"
				@cancel="$router.push({name: 'app-visit-point-list'})"
			/>
		</div>
		<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
			<vs-tab :label="$t('Information')" icon-pack="feather" icon="icon-user">
				<div class="tab-text">
					<div id="user-edit-tab-info">
						<div class="vx-row">
							<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
								<vx-card :cardBorder="true" :noShadow="true" :title="$t('GeneralInformation')">
									<form>
										<div class="vx-row">
											<!--IDENTIFICATION -->
											<div class="vx-col md:w-1/2 w-full">
												<vs-input
													class="w-full"
													v-model="visitPoint.identification"
													v-validate="'required'"
													name="identification"
													:label="$t('Routing.Table.Identification')"
													:danger="dangerInput.identification.show"
													:danger-text="dangerInput.identification.text"
													@focus="() => (dangerInput.identification.show = false)"
												/>
												<span
													class="text-danger text-sm"
													v-show="errors.has('identification')"
													>{{
														$t("ResourceModule.BasicInfoForm.ValidMessages.Identification")
													}}</span
												>
											</div>
											<div class="vx-col md:w-1/2 w-full">
												<!--ADDRESS -->
												<label class="vs-input--label">{{ $t("Divipola.Address") }}</label>
												<vx-input-group>
													<vs-input
														class="w-full"
														v-model="visitPoint.address"
														v-validate="'required'"
														name="address"
														:danger="dangerInput.address.show"
														:danger-text="dangerInput.address.text"
														@focus="() => (dangerInput.address.show = false)"
														@change="showGeoAgaing = true"
													/>
													<template v-if="showGeoAgaing" slot="append">
														<div class="append-text btn-addon">
															<vx-tooltip
																class="cursor-pointer"
																style="z-index: 9999"
																color="primary"
																position="top"
																delay=".1s"
																:title="$t('Divipola.GeoAgain')"
																:text="$t('Divipola.GeoSub')"
															>
																<vs-button
																	icon-pack="feather"
																	icon="icon-globe"
																	@click.prevent="geoCoder"
																></vs-button>
															</vx-tooltip>
														</div>
													</template>
												</vx-input-group>
												<span class="text-danger text-sm" v-show="errors.has('address')">{{
													$t("ResourceModule.BasicInfoForm.ValidMessages.Address")
												}}</span>
											</div>
										</div>
										<div class="vx-row">
											<!-- COUNTRY -->
											<div class="vx-col md:w-1/2 w-full">
												<label class="vs-input--label">{{ $t("Divipola.Country") }}</label>
												<v-select
													v-model="selectedCountry"
													v-validate="'required'"
													name="country"
													:disabled="
														visitPoint.address === '' ||
														visitPoint.address === null ||
														visitPoint.address === undefined
													"
													:clearable="false"
													:options="countriesOptions"
													:dir="$vs.rtl ? 'rtl' : 'ltr'"
												>
													<template v-slot:no-options="{search, searching}">
														<template v-if="searching">
															{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
														</template>
														<template v-else>
															{{ $t("NoResultsFound") }}
														</template>
													</template>
												</v-select>
												<span class="text-danger text-sm" v-show="errors.has('country')">{{
													$t("ResourceModule.BasicInfoForm.ValidMessages.Country")
												}}</span>
											</div>
											<div class="vx-col md:w-1/2 w-full">
												<!--Department -->
												<label class="vs-input--label">{{
													getPoliticalDivision.department
												}}</label>
												<v-select
													v-model="dpto_local_sel"
													v-validate="'required'"
													name="departments"
													:loading="departments.length <= 0 && selectedCountry ? true : false"
													:disabled="
														departments.length <= 0 ||
														visitPoint.address === '' ||
														visitPoint.address === null ||
														visitPoint.address === undefined
													"
													:clearable="false"
													:options="departments"
													:dir="$vs.rtl ? 'rtl' : 'ltr'"
												>
													<template v-slot:no-options="{search, searching}">
														<template v-if="searching">
															{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
														</template>
														<template v-else>
															{{ $t("NoResultsFound") }}
														</template>
													</template>
												</v-select>
												<span class="text-danger text-sm" v-show="errors.has('departments')">{{
													$t("ValidateField", {
														n: getPoliticalDivision.department.toLowerCase(),
													})
												}}</span>
											</div>
										</div>
										<div class="vx-row">
											<div class="vx-col md:w-1/2 w-full">
												<label class="vs-input--label">{{ getPoliticalDivision.city }}</label>
												<v-select
													v-model="city_local_sel"
													v-validate="'required'"
													name="cities"
													:loading="
														cities.length <= 0 && dpto_local_sel && selectedCountry
															? true
															: false
													"
													:disabled="
														cities.length <= 0 ||
														visitPoint.address === '' ||
														visitPoint.address === null ||
														visitPoint.address === undefined
													"
													:clearable="false"
													:options="cities"
													:dir="$vs.rtl ? 'rtl' : 'ltr'"
												>
													<template v-slot:no-options="{search, searching}">
														<template v-if="searching">
															{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
														</template>
														<template v-else>
															{{ $t("NoResultsFound") }}
														</template>
													</template>
												</v-select>
												<span class="text-danger text-sm" v-show="errors.has('cities')">{{
													$t("ValidateField", {n: getPoliticalDivision.city.toLowerCase()})
												}}</span>
											</div>
											<div class="vx-col md:w-1/2 w-full">
												<label class="vs-input--label">{{ $t("Status.Title") }}</label>
												<v-select
													v-model="status_local_sel"
													:clearable="false"
													:options="statusOptions"
													v-validate="'required'"
													name="status"
												>
													<template v-slot:no-options="{search, searching}">
														<template v-if="searching">
															{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
														</template>
														<template v-else>
															{{ $t("NoResultsFound") }}
														</template>
													</template>
												</v-select>
												<span class="text-danger text-sm" v-show="errors.has('status')">{{
													$t("ResourceModule.BasicInfoForm.ValidMessages.Status")
												}}</span>
											</div>
										</div>
										<div class="vx-row mt-2">
											<div class="vx-col w-full sm:w-1/1 md:w-3/5">
												<small class="date-label">{{
													$t("Routing.CreateVisitPoint.ServiceTime")
												}}</small>
												<div class="flex flex-row justify-between">
													<vs-input-number
														v-model="hours"
														class="w-full mr-6"
														:label="$t('RouterSelection.Hours')"
														:min="0"
														:max="23"
														@keypress="validateInputNumber"
														@change="validateDateHours"
													/>
													<vs-input-number
														v-model="minutes"
														class="w-full"
														:label="$t('RouterSelection.Minutes')"
														:min="0"
														:max="59"
														@keypress="validateInputNumberMinutes"
														@change="validateDateMinutes"
													/>
												</div>
											</div>
											<div class="vx-col w-full sm:w-1/1 md:w-2/5">
												<small class="date-label ml-6">{{ $t("Priority") }}</small>
												<vs-input-number
													v-model="visitPoint.priority"
													class="ml-6"
													:min="0"
													:max="100"
													@keypress="validateInputNumberPriority"
													@change="validateDatePriority"
												/>
											</div>
										</div>
									</form>
								</vx-card>
								<vx-card class="mt-base" :cardBorder="true" :noShadow="true">
									<div class="flex justify-between items-center mb-4">
										<h4>{{ $t("AdditionalFields") }}</h4>
										<vs-button
											class="ml-2 mr-2"
											color="primary"
											icon-pack="feather"
											icon="icon-plus"
											@click.prevent="showPrompt()"
											>{{ $t("VisitPoints.Add") }}
										</vs-button>
									</div>
									<vs-table :data="propertiesList" noDataText="">
										<template slot="thead">
											<vs-th>{{ $t("Label") }}</vs-th>
											<vs-th>{{ $t("Routing.Table.Type") }}</vs-th>
											<vs-th>{{ $t("Value") }}</vs-th>
											<vs-th>{{ $t("Routing.Table.Actions") }}</vs-th>
										</template>

										<template slot-scope="{data}">
											<vs-tr :key="indextr" v-for="(tr, indextr) in data">
												<vs-td :data="data[indextr].label">{{ data[indextr].label }}</vs-td>
												<vs-td :data="data[indextr].type.value">{{
													data[indextr].type.value
												}}</vs-td>
												<vs-td :data="data[indextr].value">{{ data[indextr].value }}</vs-td>
												<vs-td>
													<feather-icon
														icon="EditIcon"
														svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
														@click="editSelect(data[indextr], indextr)"
													/>
													<feather-icon
														icon="Trash2Icon"
														svgClasses="h-5 w-5 hover:text-danger ml-2 cursor-pointer"
														@click="deleteItem(data[indextr], indextr)"
													/>
												</vs-td>
											</vs-tr>
										</template>
									</vs-table>
									<vs-prompt
										:title="$t('PropertyDefinition')"
										:active.sync="showPromptField"
										:acceptText="$t('Accept')"
										:cancelText="$t('Cancel')"
										:is-valid="validFormAdditionalFields"
										@accept="addProperty(property)"
									>
										<div class="vx-row mt-2">
											<div class="vx-col w-full mt-2">
												<small class="date-label cursor-pointer">
													{{ $t("Label") }}: ({{ $t("LabelHelp") }})
													<i
														class="material-icons ml-1 text-center"
														style="font-size: 14px"
														:title="$t('AcceptsNumbersAndTheDashSign')"
													>
														info
													</i>
												</small>
												<vs-input
													v-model.trim="property.label"
													class="w-full"
													name="label"
													:vs-placeholder="$t('Label')"
													:placeholder="$t('Label')"
													:disabled="isUpdate"
													@keypress="validateKeyAdditionalInfo"
												/>
											</div>
											<div class="vx-col w-full">
												<small class="date-label">{{ $t("ResourceModule.Create.Type") }}</small>
												<v-select
													v-model="property.type"
													name="type"
													:options="type"
													:dir="$vs.rtl ? 'rtl' : 'ltr'"
													:clearable="false"
												>
													<template v-slot:no-options="{search, searching}">
														<template v-if="searching">
															{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
														</template>
														<template v-else>
															{{ $t("NoResultsFound") }}
														</template>
													</template>
												</v-select>
											</div>
											<div class="vx-col w-full mt-2">
												<small class="date-label"
													>{{ $t("Value") }}: ({{ $t("TagValue") }})</small
												>
												<flat-pickr
													v-if="property.type.value === 'datetime'"
													class="w-full"
													v-model="property.value"
													:placeholder="$t('Select')"
													:config="configdateTimePicker"
												/>
												<vs-input
													v-else
													v-model.trim="property.value"
													class="w-full"
													:type="property.type.value"
													:placeholder="
														property.type.value === 'date' || property.type.value === 'time'
															? ''
															: $t('Value')
													"
													:vs-placeholder="$t('Value')"
												/>
											</div>
										</div>
									</vs-prompt>
								</vx-card>
							</div>
							<div class="vx-col md:w-1/2 sm:w-1/2 w-full">
								<vx-card :cardBorder="true" :noShadow="true">
									<div class="vx-row">
										<div class="vx-col md:w-1/2 w-full">
											<vs-input
												class="w-full mb-4"
												v-model="visitPoint.cy"
												name="cy"
												disabled
												:label="$t('Deposits.Form.Latitude')"
											/>
											<span class="text-danger text-sm" v-show="errors.has('cy')">{{
												errors.first("cy")
											}}</span>
										</div>
										<div class="vx-col md:w-1/2 w-full">
											<vs-input
												class="w-full mb-4"
												v-model="visitPoint.cx"
												name="cx"
												disabled
												:label="$t('Deposits.Form.Longitude')"
											/>
											<span class="text-danger text-sm" v-show="errors.has('cx')">{{
												errors.first("cx")
											}}</span>
										</div>
									</div>
									<google-map
										v-if="showMap"
										name="map-visitpoint"
										latitude="4.686699"
										longitude="-74.0837187"
										zoom="13"
										theme="uber"
										calledFrom="visitpoint"
										ref="moduleMap"
										@geoInversoEmit="geoInverso"
									></google-map>
								</vx-card>
							</div>
						</div>
						<vs-prompt
							:title="null"
							:active.sync="activePrompt"
							@cancel="close()"
							@accept="acceptAlert()"
							@close="close()"
						>
							<div class="con-exemple-prompt">
								<p>
									{{ $t("Deposits.Form.GeoRef.Finded") }}
								</p>
								<vs-input
									placeholder="Code"
									vs-placeholder="Code"
									v-model="dataGeo.address1"
									class="mt-3 w-full mb-4"
								/>
								<p>{{ $t("Deposits.Form.GeoRef.UseVisitPoint") }}</p>
							</div>
						</vs-prompt>
					</div>
				</div>
			</vs-tab>
			<vs-tab :label="$t('VisitPoints.Add') + ' ' + $t('Skills.Skills')" icon-pack="feather" icon="icon-award">
				<div class="tab-text">
					<assigned-skill-list
						:isAssignedSkills="false"
						:skillListIds="skillsIds"
						:customConfig="skillListConfig"
					/>
				</div>
			</vs-tab>
			<vs-tab
				:label="$t('VisitPoints.Add') + ' ' + $t('Capacity.Capabilities')"
				icon-pack="feather"
				icon="icon-box"
			>
				<div class="tab-text">
					<assigned-capacity-list
						:capacities="
							visitPoint.capacities && visitPoint.capacities.length > 0 ? visitPoint.capacities : []
						"
						:is-demand="true"
						:is-type-service="true"
						:capacityListIds="capacityIds"
						:navbarOptions="true"
						:columns="columnsCapacity"
						:defaultColumns="defaultColumnsCapacity"
						:isAssignedCapacities="false"
					/>
				</div>
			</vs-tab>
			<vs-tab
				:label="($t('VisitPoints.Add') + ' ' + $t('TimeWindow.TimeWindows')) | capitalize"
				icon-pack="feather"
				icon="icon-clock"
			>
				<div class="tab-text">
					<assigned-time-window-list
						:navbarOptions="true"
						:time_window_ids="timeWindowIds"
						:isAssignedTimeWindows="false"
					/>
				</div>
			</vs-tab>
			<vs-tab
				:label="$t('VisitPoints.Add') + ' ' + $t('Frequency.Frequencies')"
				icon-pack="feather"
				icon="icon-radio"
			>
				<div class="tab-text">
					<assigned-frequency-list
						:isAssignedFrequencies="false"
						:navbarOptions="true"
						:frequencyIds="frequencyIds"
					/>
				</div>
			</vs-tab>
		</vs-tabs>
	</div>
</template>

<script>
import {visitPointEditMixin} from "../model/VisitPointEditMixin.js";

export default {
	mixins: [visitPointEditMixin],
};
</script>
